import type React from 'react'

import Link from 'next/link'

import type { RelativeUrlObject } from '@b-stock/fe-core/bstock-react'

import buyUrlPrefix from '@/buyer-portal/buyUrlPrefix'

const LegacyBpLink = ({
  href,
  ...linkProps
}: Omit<React.ComponentPropsWithoutRef<typeof Link>, 'href'> & {
  href: string | RelativeUrlObject
}) => {
  let fixedHref: typeof href
  if (typeof href === 'string') {
    if (href.startsWith('/') && !href.startsWith(buyUrlPrefix)) {
      fixedHref = `${buyUrlPrefix}${href}`
    } else {
      fixedHref = href
    }
  } else {
    const { pathname } = href
    fixedHref = {
      ...href,
      pathname: pathname.startsWith(buyUrlPrefix)
        ? pathname
        : `${buyUrlPrefix}${pathname}`,
    }
  }
  return <Link href={fixedHref} {...linkProps} />
}

export default LegacyBpLink
